export class HeaderState {
  title?: string;
  class?: string;
}
